// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

// Utiliser les variables d'environnement
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Vérification que les variables sont bien définies
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ ERREUR: Variables d\'environnement Supabase manquantes!')
  console.error('Vérifiez que .env.development ou .env.production existe')
  throw new Error('Configuration Supabase manquante')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// 🆕 Exposer dans window pour les scripts console
if (typeof window !== 'undefined') {
  window.supabase = supabase
  console.log('✅ Supabase client initialisé')
  console.log('📍 Environnement:', process.env.REACT_APP_ENV || 'non défini')
  console.log('🔗 URL:', supabaseUrl)
}